import styled from 'styled-components';

export const OrderViewPriceDetailsListItemWrapper = styled.div.attrs({
  className: 'order-view-price-details-list-item-wrapper',
})`
  padding: 1.5rem 0;
  margin: 0 0.5rem;
`;
